module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/prod-04-dece2af4c4cc5f29c390769538a8cbde.jpg";